// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".create-guestbook{width:100%}", "",{"version":3,"sources":["/usr/src/app/src/containers/Epilogg/Create/components/CreateGuestbook/CreateGuestbook.scss"],"names":[],"mappings":"AACA,kBACI,UAAA","file":"CreateGuestbook.scss","sourcesContent":["@import \"variables\"; @import \"mixins\";\n.create-guestbook {\n    width: 100%;\n}\n"]}]);
// Exports
module.exports = exports;
